import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import type { ApiServerEntityIDType } from '../../../types';
import { PromocodeType } from './type';

export class PromocodeViewModel {
  @Expose()
  @ApiProperty()
  id: string;

  @Expose()
  @ApiProperty()
  type: PromocodeType;

  /**
   * Period in ISO8601
   * @example P3Y6M4DT12H30M5S
   */
  @Expose()
  @ApiProperty()
  freePeriod?: string;

  @Expose()
  @ApiProperty()
  createdAt: string;

  @Expose()
  @ApiProperty()
  ownedByClientId?: ApiServerEntityIDType;
}
